import React from "react";
import Select from "react-select";
import { useRef, useState } from "react";
import PhoneInput, { isValidPhoneNumber } from "react-phone-number-input";
import ReCAPTCHA from "react-google-recaptcha";

import Button from "@/components/Button";
import errorMessages from "@/constant/errorMessages";
import regExpressions from "@/constant/regExpressions";
import defaultValues from "@/constant/defaultValues";
import { showSuccessMessage } from "@/utils/common";
import { useDispatch, useSelector } from "react-redux";
import { selectFormattedCountries } from "@/store/modern/slices/countrySlice";
import { createInquiry } from "@/store/modern/slices/inquirySlice";

const BookADemo = (props) => {
  const dispatch = useDispatch();
  // const { created, loading } = useSelector((state) => state.inquiries);

  const [formData, setFormData] = useState({
    company_name: "",
    website_url: "",
    name: "",
    email: "",
    phone: "",
    country_id: "",
    city_id: "",
    inquiry_message: "",
    isNewVal: false,
    recapchVal: "",
    trade_mode_type: "logistic"
  });

  var [isButtonDisabled, setisButtonDisabled] = useState(false);

  const [errors, setErrors] = useState({});
  const { EMAIL_FIELD_MAX_LENGTH, IGNORE_EMAILS } = defaultValues;
  const [selectedCountry, setSelectedCountry] = useState(null);
  const [countryCode, setSelectedCountryCode] = useState(null);
  const [phoneValue, setphoneValue] = useState();
  const [recaptchaValue, setRecapchaValue] = useState(null);
  const recaptcha = useRef();

  const countries = useSelector(selectFormattedCountries);

  const styleError = {
    display: "block",
  };

  const errorStyle = `
    .error-show {
      .input-pad {
        .Drop-down-menu__control, .creatable_react_select__control, .input, &.split, .ck.ck-editor__editable, .ck.ck-sticky-panel__content {
          border: 1px solid #df0024 !important;
        }
      }
    }
`;


  const handleCountryChange = (cval) => {
    setSelectedCountryCode(cval.countryCode);
    setphoneValue("");

    const countryId = cval.countryId;
    setSelectedCountry(cval);

    let errorObj = { ...errors };
    errorObj.country_id = "";
    setErrors(errorObj);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        country_id: countryId,
      };
    });
  };

  const handlePhoneChange = (val) => {
    setphoneValue(val);
    setFormData((prevalue) => {
      return {
        ...prevalue,
        phone: val,
      };
    });
    let errorObj = { ...errors };
    errorObj.phone = "";
    setErrors(errorObj);
  };

  const handleRecaptchaChange = (value) => {
    setRecapchaValue(value);
    setErrors((prevErrors) => ({
      ...prevErrors,
      recaptcha: value ? "" : "Please complete the reCAPTCHA",
    }));

    setFormData((prevForm) => ({
      ...prevForm,
      recapchVal: value ? value : "",
    }));
  };

  const handleChange = (e) => {
    setFormData((prevalue) => {
      return {
        ...prevalue,
        [e.target.name]: e.target.value,
      };
    });
  };

  const handleTradeModeChange = (e) => {
    setFormData({ ...formData, trade_mode_type: e.target.value });
  };
  
  const handleFocusOut = (e) => {
    let flag = 0;
    let er = { ...errors };
    if (e.target.name === "company_name") {
      if (e.target.value === "") {
        flag = 1;
        er.company_name = errorMessages.FIELD_REQUIRED;
      } else {
        const regExp = regExpressions.company_name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.company_name = "";
        }
      }
    }

    if (e.target.name === "website_url") {
      if (e.target.value === "") {
        flag = 1;
        er.website_url = errorMessages.FIELD_REQUIRED;
      } else {
        const regExp = regExpressions.website_url;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.website_url = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.website_url = "";
        }
      }
    }

    if (e.target.name === "name") {
      if (e.target.value === "") {
        flag = 1;
        er.name = errorMessages.FIELD_REQUIRED;
      }
      else {
        const regExp = regExpressions.name;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.name = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.name = "";
        }
      }
    }

    if (e.target.name === "email") {
      if (e.target.value === "") {
        flag = 1;
        er.email = errorMessages.FIELD_REQUIRED;
      } else if (e.target.value.length > EMAIL_FIELD_MAX_LENGTH) {
        flag = 1;
        er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
      } else {
        const currentEmail = e.target.value.split("@")[1];
        const regExp = regExpressions.email;
        const check = regExp.test(e.target.value);
        if (check === false) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else if (IGNORE_EMAILS.includes(currentEmail)) {
          flag = 1;
          er.email = errorMessages.IN_VALID_FIELD_FORMAT;
        } else {
          flag = 0;
          er.email = "";
        }
      }
    }

    if (e.target.name === "inquiry_message") {
      if (e.target.value === "") {
        flag = 1;
        er.inquiry_message = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 0;
        er.inquiry_message = "";
      }
    }

    setErrors(er);
    if (flag === 0) {
      setisButtonDisabled(false);
      return false;
    } else {
      setisButtonDisabled(true);
      return true;
    }
  };

  const validateForm = () => {
    setErrors({});
    let er = {};
    let flag = 0;
    if (formData.company_name === "") {
      flag = 1;
      er.company_name = errorMessages.FIELD_REQUIRED;
    } else {
      const regExp = regExpressions.company_name;
      const check = regExp.test(formData.company_name);
      if (check === false) {
        flag = 1;
        er.company_name = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.website_url === "") {
      flag = 1;
      er.website_url = errorMessages.FIELD_REQUIRED;
    } else {
      const regExp = regExpressions.website_url;
      const check = regExp.test(formData.website_url);
      if (check === false) {
        flag = 1;
        er.website_url = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }
    if (formData.name === "") {
      flag = 1;
      er.name = errorMessages.FIELD_REQUIRED;
    } else {
      const regExp = regExpressions.name;
      const check = regExp.test(formData.name);
      if (check === false) {
        flag = 1;
        er.name = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.email === "") {
      flag = 1;
      er.email = errorMessages.FIELD_REQUIRED;
    } else if (formData.email.length > EMAIL_FIELD_MAX_LENGTH) {
      flag = 1;
      er.email = errorMessages.MAX_LENGTH_150_EXCEEDED;
    } else {
      const currentEmail = formData.email.split("@")[1];
      const regExp = regExpressions.email;
      const check = regExp.test(formData.email);
      if (check === false) {
        flag = 1;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      } else if (IGNORE_EMAILS.includes(currentEmail)) {
        flag = 1;
        er.email = errorMessages.IN_VALID_FIELD_FORMAT;
      }
    }

    if (formData.country_id === "") {
      flag = 1;
      er.country_id = errorMessages.FIELD_REQUIRED;
    }
    if (formData.inquiry_message === "") {
      flag = 1;
      er.inquiry_message = errorMessages.FIELD_REQUIRED;
    }
    if (
      phoneValue === undefined ||
      !phoneValue ||
      !isValidPhoneNumber(phoneValue)
    ) {
      if (phoneValue === undefined || phoneValue === "") {
        flag = 1;
        er.phone = errorMessages.FIELD_REQUIRED;
      } else {
        flag = 1;
        er.phone = errorMessages.CONTACT_NUMBER_VALIDATION_MSG;
      }
    }

    if (recaptchaValue === null) {
      flag = 1;
      er.recaptcha = "Please verify the reCAPTCHA!";
    }
    setErrors(er);
    if (flag === 1) {
      return false;
    } else {
      return true;
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (validateForm()) {
      setisButtonDisabled(true);

      const resultAction = await dispatch(createInquiry(formData));

      if (createInquiry.fulfilled.match(resultAction)) {
        const response = resultAction.payload;

        recaptcha.current.reset();
        if (response?.status === true) {
          showSuccessMessage(response.message);
          //props.showSuccess()
          const frmdata = {
            company_name: "",
            website_url: "",
            name: "",
            email: "",
            phone: "",
            country_id: "",
            city_id: "",
            inquiry_message: "",
            isNewVal: false,
            recapchVal: "",
            trade_mode_type: "logistic"
          };
          setFormData(frmdata);
          setSelectedCountry(null);
          setSelectedCountryCode(null);
          setphoneValue(null);
          setErrors({});
          setRecapchaValue(null);
          recaptcha.current.reset();
          setisButtonDisabled(false);
          setTimeout(() => {
            props.setSmallModalShow(false);
          }, 3000);

        } else {
          const newErrors = {};
          if (response?.error) {
            if (response.error.company_name) {
              newErrors.company_name =
                response.error.company_name[0];
            }
            if (response.error.website_url) {
              newErrors.website_url = response.error.website_url[0];
            }
            if (response.error.name) {
              newErrors.name = response.error.name[0];
            }
            if (response.error.email) {
              newErrors.email = response.error.email[0];
            }
            if (response.error.phone) {
              newErrors.phone = response.error.phone[0];
            }
            if (response.error.country_id) {
              newErrors.country_id = response.error.country_id[0];
            }
            if (response.error.inquiry_message) {
              newErrors.inquiry_message =
                response.error.inquiry_message[0];
            }
            if (response.error.recapchVal) {
              newErrors.recaptcha = 'Please verify the reCAPTCHA!';
            }
          }
          setErrors(newErrors);
        }
        setisButtonDisabled(false);
      }
    } else {
      setisButtonDisabled(false);
    }
  };

  return (
    <section className="form-wrape">
      <div className="form-pad">
        {/* <div className="section-head">
          <div className="head">
            <h2 className="head">
              Book Demo
            </h2>
          </div>
        </div> */}
        <style>{errorStyle}</style>
        <form onSubmit={handleSubmit}>
          <div className="row">
                 <div className="d-flex mb-3">
                  <div className="d-inline">
                    <input type="radio" name="userType" value="logistic" className="custom-radio"  
                    checked={formData.trade_mode_type === "logistic"}
                    onChange={handleTradeModeChange}/>
                  <label>Logistic</label>
                    
                  </div>
  
                <div className="d-inline ms-3">
                  <input type="radio" name="userType" value="supplier" className="custom-radio"
                   checked={formData.trade_mode_type === "supplier"}
                    onChange={handleTradeModeChange} />
                      <label>Supplier</label>
                </div>
              </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.company_name ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <input
                    type="text"
                    className="input"
                    id="contact-form-company_name"
                    autoComplete="new-off"
                    placeholder="Enter company name *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    name="company_name"
                    value={formData.company_name}
                  />
                  {errors.company_name && (
                    <div className="invalid-feedback" style={styleError}>
                      {errors.company_name}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.website_url ? 'error-show' : ''} `}>
                <div className="input-pad">
                  <input
                    type="text"
                    className="input"
                    id="contact-form-website_url"
                    autoComplete="new-off"
                    placeholder="Enter website *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    name="website_url"
                    value={formData.website_url}
                  />
                  {errors.website_url && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.website_url}{" "}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.name ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <input
                    type="text"
                    className="input"
                    id="contact-form-fullname"
                    autoComplete="new-off"
                    placeholder="Enter full name *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    name="name"
                    value={formData.name}
                  />
                  {errors.name && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.name}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.email ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <input
                    type="text"
                    id="contact-form-email"
                    className="input"
                    autoComplete="new-off"
                    placeholder="Enter your email *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    name="email"
                    value={formData.email}
                  />
                  {errors.email && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.email}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.country_id ? 'error-show' : ''}`}>
                <div className="input-pad select-wrape v3">
                  <Select
                    options={countries}
                    value={selectedCountry}
                    onChange={handleCountryChange}
                    placeholder="Select country *"
                    className="select"
                    classNamePrefix={"Drop-down-menu"}
                  />
                  {errors.country_id && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.country_id}
                    </div>
                  )}
                </div>
              </div>
            </div>
            <div className="col-xxl-6 col-xl-6 col-lg-6 col-md-6">
              <div className={`input-wrape ${errors.phone ? 'error-show' : ''}`}>
                <div className="input-pad">
                  <PhoneInput
                    id="contact-form-phone"
                    className="input"
                    name="phone"
                    international
                    limitMaxLength
                    placeholder="Enter contact *"
                    defaultCountry={countryCode}
                    value={phoneValue}
                    onChange={handlePhoneChange}
                  />
                  {errors.phone && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.phone}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-12">
              <div className={`input-wrape ${errors.inquiry_message ? 'error-show' : ''} `}>
                <div className="input-pad">
                  <textarea
                    id="contact-form-message"
                    className="input"
                    rows="3"
                    placeholder="Write a message *"
                    onChange={handleChange}
                    onBlur={handleFocusOut}
                    name="inquiry_message"
                    value={formData.inquiry_message}
                  ></textarea>
                  {errors.inquiry_message && (
                    <div
                      className="invalid-feedback"
                      style={styleError}
                    >
                      {errors.inquiry_message}
                    </div>
                  )}
                </div>
              </div>
            </div>

            <div className="col-xxl-8 col-xl-8 col-lg-8 col-md-8">
              <div className="captcha-wrapes">
                <ReCAPTCHA
                  sitekey={process.env.REACT_APP_SITE_KEY}
                  onChange={handleRecaptchaChange}
                  ref={recaptcha}
                  onExpired={() => {
                    setRecapchaValue(null); // Reset recaptcha value on expiration
                    setErrors((prevErrors) => ({
                      ...prevErrors,
                      recaptcha: "Please complete the reCAPTCHA",
                    }));
                    setFormData((prevalue) => {
                      return {
                        ...prevalue,
                        recapchVal: ""
                      };
                    });
                  }}
                />
                {errors.recaptcha && (
                  <div
                    className="invalid-feedback"
                    style={styleError}
                  >
                    {" "}
                    {errors.recaptcha}{" "}
                  </div>
                )}
              </div>
            </div>

            <div className="col-xxl-4 col-xl-4 col-lg-4 col-md-4 inquiry-form-btn">
              <Button
                className="btn secondry-btn"
                type="submit"
                disabled={isButtonDisabled}
              >
                Submit
              </Button>
            </div>
          </div>
        </form>
        {/* {successmsg && (
                          <div className="alert alert-success mt-3">
                            {successmsg}
                          </div>
                        )} */}
      </div>
      {/* <ToastContainer /> */}
    </section>
  );
};

export default React.memo(BookADemo);
